import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
const COMPONENT_NAME = "Admin responseManager/services/CannedResponseService";

/**
 * Gets all of the canned response categories from Dynamo table
 */
export const getAllCannedResponseCategories = async () => {
	try {
		let response = await axios.get(`${APIGateways.cannedResponsesEndpoint}`, {
			headers: await getAuthHeader(),
		});
		return response.data.result;
	} catch (error) {
		v2.error(`Error getting all canned response categories`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_CANNED_RESPONSE_CATEGORIES_LIST_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
export const updateCannedResponseCategory = async (categoryName, category) => {
	try {
		let response = await axios.put(`${APIGateways.cannedResponsesEndpoint}/${categoryName}`, category, {
			headers: await getAuthHeader(),
		});
		return response.data.result;
	} catch (error) {
		v2.error(`Error updating canned response category`, {
			additionalData: {
				error: errorToObject(error),
				category,
			},
			logCode: errorCodes.UPDATE_CANNED_RESPONSE_CATEGORY_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const deleteCannedResponseCategory = async (categoryName, categoryId) => {
	try {
		let response = await axios.delete(`${APIGateways.cannedResponsesEndpoint}/${categoryName}/${categoryId}`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error deleting canned response category`, {
			additionalData: {
				error: errorToObject(error),
				categoryName,
			},
			logCode: errorCodes.DELETE_CANNED_RESPONSE_CATEGORY_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
